import React from 'react';

import { If } from 'utils';
import ExpandableSection from 'components/ExpandableSection';
import { useNotes } from 'utils/hooks';

export default function Container({ children = null }) {
  const { notes, isError, isLoading, isDisabled } = useNotes();

  return (
    <ExpandableSection
      title="Notes"
      isError={isError}
      isLoading={isLoading}
      isDisabled={isDisabled}
      badgeText={isLoading ? null : `${notes.length}`}
    >
      <If test={!isLoading}>{children}</If>
    </ExpandableSection>
  );
}
